import { call, CallEffect, put, PutEffect } from 'redux-saga/effects';
import { getData } from '../shared/fetchApi';
import { ArtikelZulage, ArtikelZulageFilter } from '../shared/types/artikelZulage';
import { GetArtikelZulagenAction, getArtikelZulagenSucceededAction, getArtikelZulagenFailedAction } from '../store/ArtikelZulage.store';

function pickPriceForWerk(
    prices: Array<{ werkId?: string; preis?: number; einheit?: string; waehrung?: string }>,
    requestedWerkId: string | undefined
): { preis?: number; einheit?: string; waehrung?: string } | undefined {
    if (!requestedWerkId || !prices?.length) return prices?.[0];
    const match = prices.find((p) => {
        const id = p.werkId;
        if (!id) return false;
        if (id === requestedWerkId) return true;
        return id
            .split(',')
            .map((s) => s.trim())
            .includes(requestedWerkId);
    });
    return match ?? prices[0];
}

export function buildArtikelZulageUrl(filter: ArtikelZulageFilter): string {
    const { artikelgruppeId, werkId, partnerNummer: warenempfaengerPartnerNummer, rechnungsempfaengerPartnerNummer } = filter;

    if (rechnungsempfaengerPartnerNummer && warenempfaengerPartnerNummer) {
        if (werkId) {
            return `artikel-zulage/rechnungsempfaenger/${rechnungsempfaengerPartnerNummer}/warenempfaenger/${warenempfaengerPartnerNummer}/artikelgruppe/${artikelgruppeId}/werk/${werkId}`;
        }
        return `artikel-zulage/rechnungsempfaenger/${rechnungsempfaengerPartnerNummer}/warenempfaenger/${warenempfaengerPartnerNummer}/artikelgruppe/${artikelgruppeId}`;
    }

    if (werkId) {
        return `artikel-zulage/artikelgruppe/${artikelgruppeId}/werk/${werkId}/partner/${warenempfaengerPartnerNummer}`;
    }

    return `artikel-zulage/artikelgruppe/${artikelgruppeId}/partner/${warenempfaengerPartnerNummer}`;
}

export function* getArtikelZulagenSaga(action: GetArtikelZulagenAction): IterableIterator<PutEffect | CallEffect> {
    const { filter } = action;
    const { artikelgruppeId, werkId, partnerNummer } = filter;

    try {
        const url = buildArtikelZulageUrl(filter);

        const response = yield call(getData, url);
        const zulagen: ArtikelZulage[] = (response || []).map((z: any) => {
            const priceForWerk = pickPriceForWerk(Array.isArray(z.prices) ? z.prices : [], werkId);
            return {
                id: z.artikelZulageCode || z.id || '',
                bezeichnung: z.name || z.bezeichnung || '',
                artikelgruppeId: Array.isArray(z.artikelgruppen) ? z.artikelgruppen[0] : z.artikelgruppeId || '',
                werkId: werkId || undefined,
                partnerNummer: partnerNummer,
                dosierbereichMin: z.minDosierung ?? z.dosierbereichMin,
                dosierbereichMax: z.maxDosierung ?? z.dosierbereichMax,
                preis: priceForWerk?.preis ?? z.preis,
                waehrung: priceForWerk?.waehrung ?? z.waehrung,
                einheit: priceForWerk?.einheit ?? undefined,
                aktiv: z.aktiv !== undefined ? z.aktiv : true,
            };
        });

        yield put(getArtikelZulagenSucceededAction({ zulagen, filter }));
    } catch (error) {
        yield put(getArtikelZulagenFailedAction());
    }
}
